import { Trans } from '@lingui/macro'
import { Typography } from '@material-ui/core'
import React from 'react'

import { CenterContainer } from '../atoms/CenterContainer'
import { ContactButton } from '../atoms/ContactButton'
import { LoaderSpinner } from '../atoms/LoaderSpinner'
import { MainLayout } from '../organisms/MainLayout'

interface IProps {}

export const ClientWaitPage: React.FC<IProps> = props => {
  return (
    <MainLayout>
      <CenterContainer>
        <br />
        <LoaderSpinner />
        <br />
        <Typography variant="h5">
          <Trans>
            Probíhá dokončování registrace Vašeho obchodu. Prosíme o chvíli
            strpení.
          </Trans>
        </Typography>
        <br />
        <br />
        <Typography variant="h6">
          <Trans>
            Pokud nedojde ke spuštění aplikace přibližně do 5 minut
            <ContactButton />
          </Trans>
        </Typography>
      </CenterContainer>
    </MainLayout>
  )
}
